// Core
import { NavigationGuard } from "vue-router";
import { until } from "@vueuse/core";

// Stores
import pinia from "@/store/pinia";

// Stores
import { useTeamStore } from "@/store/team";
import { useUserStore } from "@/store/user";

const requirePlan: NavigationGuard = async (to, _from, next) => {
  try {
    const userStore = useUserStore(pinia);
    const teamStore = useTeamStore(pinia);

    // Aguarda o carregamento dos dados do team store se estiver carregando
    if (teamStore.loading) {
      await until(() => teamStore.loading).toBe(false);
    }

    const infos = userStore.userInfos;
    const onboarding = infos?.onboarding;
    const completed = onboarding?.hasCompleted || onboarding?.hasCompletedStep2;

    if (teamStore.teamIsLeadMachineOnly && completed) {
      if ((to.name as string)?.includes("leads")) {
        next();
      } else {
        next({ name: "leads" });
      }
    } else {
      if (completed) return next();

      const step = onboarding?.currentStep;

      if (step === 6 || step === 5) {
        // Check if invited user's team already has a valid subscription
        const isInvitedUser = onboarding?.invite;
        if (isInvitedUser && teamStore.hasValidSubscription) {
          return next();
        }
        return next("subscription");
      }

      return next("sign-up");
    }
  } catch (error) {
    next({ name: "500" });
  }
};

export default requirePlan;
